"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchFetch = exports.chunkArray = void 0;
function chunkArray(array, size) {
    return [...new Array(Math.ceil(array.length / size)).keys()].map((_, index) => array.slice(index * size, (index + 1) * size));
}
exports.chunkArray = chunkArray;
async function batchFetch(addresses, fetchBatch, chunkSize = 100 // limit for web3 client getMultipleAccounts fetch
) {
    const results = await Promise.all(chunkArray(addresses, chunkSize).map(chunk => fetchBatch(chunk)));
    return results.reduce((acc, curr) => acc.concat(...curr), new Array());
}
exports.batchFetch = batchFetch;
//# sourceMappingURL=array.js.map